<template>
  <div class="container">
    <div class="root">
      <div class="root__header">
        <img class="root__icon" src="@/assets/icons/doc-icon.svg" alt="" />
        <p class="root__title">{{ $t("risks.title") }}</p>
      </div>
      <p class="root__description">{{ $t("risks.description") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PossibleRisksBlock",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.root {
  width: 100%;
  padding: 32px;
  margin-top: 40px;
  margin-bottom: 80px;
  border-radius: 28px;
  background-color: #e1edff0a;

  @include tablet {
    padding: rem(32);
    margin-top: rem(40);
    margin-bottom: rem(80);
    border-radius: rem(28);
  }

  @include mobile {
    padding: rem(24);
    margin-top: rem(24);
    margin-bottom: rem(48);
  }

  &__header {
    display: flex;
    align-items: center;
    padding-bottom: 16px;

    @include tablet {
      padding-bottom: rem(16);
    }
  }

  &__icon {
    width: 42px;
    min-width: 42px;
    height: 42px;
    margin-right: 16px;

    @include tablet {
      width: rem(42);
      min-width: rem(42);
      height: rem(42);
      margin-right: rem(16);
    }
  }

  &__title {
    font-weight: 700;
    font-size: 40px;
    line-height: 52px;
    color: #ffffff !important;

    @include tablet {
      font-size: rem(40);
      line-height: rem(52);
    }

    @include mobile {
      font-size: rem(24);
      line-height: rem(32);
    }
  }

  &__description {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #c0c0c0 !important;

    @include tablet {
      font-size: rem(16);
      line-height: rem(24);
    }

    @include mobile {
      font-size: rem(16);
      line-height: rem(24);
    }
  }
}
</style>
